// Methods whose card is in another currency than the order: the order is in RUB, the card receives its own currency.
export const FOREIGN_METHODS: Record<string, { label: string; cardCurrency: string; hint: string }> = {
  R_UZS: { label: 'RUB→UZS', cardCurrency: 'UZS', hint: 'Заявка в рублях, зачисление в сумах на узбекскую карту' },
  R_TJS: { label: 'RUB→TJS', cardCurrency: 'TJS', hint: 'Заявка в рублях, зачисление в сомони на таджикскую карту' },
};

export const R_UZS_LABEL = FOREIGN_METHODS.R_UZS.label;
export const R_UZS_HINT = FOREIGN_METHODS.R_UZS.hint;

export const isForeignMethod = (method?: string | null) => !!method && method in FOREIGN_METHODS;

export const foreignMethodOf = (paymentType?: string | null) =>
  paymentType ? Object.keys(FOREIGN_METHODS).find((method) => paymentType.includes(method)) : undefined;

export const foreignHint = (paymentType?: string | null) => {
  const method = foreignMethodOf(paymentType);
  return method ? FOREIGN_METHODS[method].hint : undefined;
};

export const hasRUzs = (paymentType?: string | null) => !!foreignMethodOf(paymentType);

export const formatPaymentType = (paymentType?: string | null) =>
  paymentType
    ? Object.entries(FOREIGN_METHODS).reduce((value, [method, { label }]) => value.replace(method, label), paymentType)
    : paymentType;
